import { cn } from "@newxsystems/shared";
import type { ITootSectionShellProps, TootSectionTone } from "./TootSectionShell.props";
import { getTootSectionSpacing } from "../../toot-section-spacing";

const toneClasses: Record<TootSectionTone, string> = {
  default: "text-inherit",
  muted: "text-inherit",
  dark: "text-inherit",
  accent: "text-inherit",
};

const widthClasses = {
  narrow: "!max-w-2xl",
  default: "",
  wide: "",
  full: "!max-w-none !px-0 md:!px-0 xl:!px-0",
};

export const TootSectionShell = ({
  actions,
  children,
  className,
  containerClassName,
  header,
  id,
  rootClassName,
  spacing,
  tone = "default",
  width = "default",
}: ITootSectionShellProps) => {
  return (
    <section
      className={cn(
        "relative overflow-hidden",
        toneClasses[tone],
        rootClassName,
        getTootSectionSpacing(spacing),
      )}
      id={id}
    >
      <div className={cn("toot-container", widthClasses[width], containerClassName)}>
        {header ? <div className="mb-10">{header}</div> : null}
        <div className={className}>{children}</div>
        {actions ? <div className="mt-10">{actions}</div> : null}
      </div>
    </section>
  );
};

TootSectionShell.displayName = "Layout::TootSectionShell";
